import React from 'react';
import { Mail, MapPin, Clock, Phone } from 'lucide-react';

const ContactInfo = () => {
  const contactItems = [
    {
      icon: Mail,
      label: 'Email',
      value: process.env.REACT_APP_CREATOR_EMAIL || 'hello@aniecabahug.dev',
      href: `mailto:${process.env.REACT_APP_CREATOR_EMAIL || 'hello@aniecabahug.dev'}`,
      color: 'text-blue-500',
      bgColor: 'bg-blue-100 dark:bg-blue-900/30'
    },
    {
      icon: MapPin,
      label: 'Location',
      value: 'Philippines',
      href: null,
      color: 'text-green-500',
      bgColor: 'bg-green-100 dark:bg-green-900/30'
    },
    {
      icon: Clock,
      label: 'Response Time',
      value: 'Within 24 hours',
      href: null,
      color: 'text-purple-500',
      bgColor: 'bg-purple-100 dark:bg-purple-900/30'
    },
    {
      icon: Phone,
      label: 'Availability',
      value: 'Available for projects',
      href: null,
      color: 'text-orange-500',
      bgColor: 'bg-orange-100 dark:bg-orange-900/30'
    }
  ];

  return (
    <div>
      <h3 className="text-xl font-bold text-gray-900 dark:text-white mb-6">
        Contact Information
      </h3>
      <div className="space-y-4">
        {contactItems.map((item, index) => (
          <div key={index} className="flex items-center space-x-4">
            <div className={`${item.bgColor} p-3 rounded-lg`}>
              <item.icon className={`w-5 h-5 ${item.color}`} />
            </div>
            <div>
              {item.href ? (
                <a
                  href={item.href}
                  className="text-gray-900 dark:text-white font-medium hover:text-blue-600 dark:hover:text-blue-400 transition-colors"
                >
                  {item.value}
                </a>
              ) : (
                <p className="text-gray-900 dark:text-white font-medium">{item.value}</p>
              )}
            </div>
          </div>
        ))}
      </div>
    </div>
  );
};

export default ContactInfo;